import { Text, ThreeDots } from 'platform-components';
import PropTypes from 'prop-types';
import React from 'react';

import './class__class-menu.scss';

class ClassMenu extends React.Component {
    static propTypes = {
        classItem: PropTypes.object.isRequired,
        disabled: PropTypes.bool,
        menuOptions: PropTypes.arrayOf(
            PropTypes.shape({
                onClick: PropTypes.func,
                textId: PropTypes.string,
                type: PropTypes.oneOf(Object.values(ThreeDots.TYPES)),
                withBorder: PropTypes.bool,
            })
        ),
    };

    setPopupRef = (ref) => {
        this.popupRef = ref;
    };

    handleOptionClick = (e, onClick) => {
        e.preventDefault();
        this.popupRef.hide();

        if (onClick) {
            const { classItem } = this.props;

            onClick(classItem);
        }
    };

    render() {
        const { disabled, menuOptions, classItem } = this.props;

        const popupProps = {
            mix: 'class__settings-popup',
            offsetLeft: -48,
            ref: this.setPopupRef,
        };

        return (
            <ThreeDots disabled={disabled} mix="class__class-row-settings" popupProps={popupProps}>
                {menuOptions &&
                    menuOptions.map((option, index) => (
                        <ThreeDots.Item
                            key={`menu-option-${index}`}
                            mix="class__settings-item"
                            onClick={(e) => this.handleOptionClick(e, option.onClick)}
                            type={option.type || ThreeDots.TYPES.ACTION}
                            withBorder={option.withBorder}
                        >
                            <Text id={option.textId} values={{ level: classItem.level }} weight={Text.WEIGHT.M} />
                        </ThreeDots.Item>
                    ))}
            </ThreeDots>
        );
    }
}

export default ClassMenu;
